import type { ReactNode } from "react";
import React from "react";
import Link, { LinkType } from "./Link";
import Title from "./Title";
import Description from "./Description";
import { styled } from "@linaria/react";
import { color } from "..";
import t from "../i18n";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  row-gap: 4px;
  background-color: ${color.darkNitrogen900};
`;

const AlignedLink = styled(Link)`
  align-self: flex-end;
`;

interface LinkProps {
  label?: string;
  value: string;
  type?: LinkType;
  className?: string;
}

interface OverlayWrapperProps {
  title?: string;
  text?: ReactNode;
  link?: LinkProps;
  className?: string;
}

const OverlayWrapper = ({ title, text, link, className }: OverlayWrapperProps) => (
  <Wrapper className={className}>
    {title && <Title value={title} />}
    {text && <Description value={text} />}
    {link && (
      <AlignedLink
        linkLabel={link.label || t("charts.info_tooltip.more")}
        linkValue={link.value}
        linkType={link.type || LinkType.INTERNAL_LINK}
      />
    )}
  </Wrapper>
);

export default React.memo(OverlayWrapper);
